import { Document } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'
import { RichText } from '~/components/RichText'
import type { RichTextOptions } from '~/components/RichText/types'
import { TypeDoDont } from '~/types/contentful'

type DoDontTableProps = {
  doDont: TypeDoDont<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

const richTextOptions: RichTextOptions = {
  extraProps: {
    [BLOCKS.LIST_ITEM]: {},
  },
  renderNode: {
    [BLOCKS.OL_LIST]: (_, children) => (
      <ol className="list-none p-0" style={{ counterReset: 'ol-counter' }}>
        {children}
      </ol>
    ),
    [BLOCKS.UL_LIST]: (_, children) => <ul className="flex flex-col gap-2 pl-1">{children}</ul>,
    [BLOCKS.LIST_ITEM]: (_, children) => (
      <li className="text-neutral-60 text-xs">
        {'•   '}
        {children}
      </li>
    ),
  },
}

export const DoDontTable = ({ doDont }: DoDontTableProps) => {
  const doRichData = {
    data: {},
    nodeType: 'unordered-list',
    content: [] as Array<Record<string, unknown>>,
  }

  const dontRichData = {
    data: {},
    nodeType: 'unordered-list',
    content: [] as Array<Record<string, unknown>>,
  }

  const { fields } = doDont
  fields?.doContent?.split('\n').map((item: string) => {
    return doRichData.content.push({
      data: {},
      nodeType: 'list-item',
      content: [
        {
          nodeType: 'text',
          data: {},
          marks: [],
          value: item.replace('- ', ''),
        },
      ],
    })
  })

  fields?.dontContent?.split('\n').map((item: string) => {
    return dontRichData.content.push({
      data: {},
      nodeType: 'list-item',
      content: [
        {
          nodeType: 'text',
          data: {},
          marks: [],
          value: item.replace('- ', ''),
        },
      ],
    })
  })

  return (
    <div className="flex flex-col gap-1 items-start self-stretch lg:flex-row lg:gap-2">
      {/*  Do Content*/}
      <div className="flex flex-col items-center flex-1 self-stretch rounded-xl bg-neutral-5 gap-3 py-6 px-3 lg:items-start lg:p-6">
        {/* Do Content Title */}
        <div className="flex w-full items-center justify-center lg:justify-start">
          <div className="flex items-start gap-2 self-stretch">
            <img className="size-[26px]" src="/images/do-icon.png" alt="do-icon" />
            <div className="flex flex-1 text-neutral-100 text-s">{fields.doTitle}</div>
          </div>
        </div>
        {/* Do Content List */}
        <RichText doc={doRichData as unknown as Document} options={richTextOptions} />
      </div>
      {/*  Don't Content*/}
      <div className="flex flex-col items-center flex-1 self-stretch rounded-xl bg-neutral-5 gap-3 py-6 px-3 lg:items-start lg:p-6">
        <div className="flex w-full items-center justify-center lg:justify-start">
          <div className="flex items-start gap-2 self-stretch">
            <img className="size-[26px]" src="/images/dont-icon.png" alt="do-icon" />
            <div className="flex flex-1 text-neutral-100 text-s">{fields.dontField}</div>
          </div>
        </div>
        {/* Don't Content List */}
        <RichText doc={dontRichData as unknown as Document} options={richTextOptions} />
      </div>
    </div>
  )
}
